// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WarningOutlinedSvg from "@ant-design/icons-svg/es/asn/WarningOutlined";
import AntdIcon from '../components/AntdIcon';

var WarningOutlined = function WarningOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WarningOutlinedSvg
  }));
};

WarningOutlined.displayName = 'WarningOutlined';
export default React.forwardRef(WarningOutlined);